/* unplugin-vue-components disabled */import { Button as __unplugin_components_0 } from 'ant-design-vue/es';
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/webp/logo.webp';
import _imports_1 from '@/assets/img/webp/paypal.webp';
import _imports_2 from '@/assets/img/webp/mastercard.webp';
import _imports_3 from '@/assets/img/webp/visa.webp';
import _imports_4 from '@/assets/img/webp/american-express.webp';
import _imports_5 from '@/assets/img/webp/dhl.webp';
import _imports_6 from '@/assets/img/webp/ems.webp';
import _imports_7 from '@/assets/img/webp/fedex.webp';
import _imports_8 from '@/assets/img/webp/ups.webp';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d417e1a6"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "content-panel"
};
var _hoisted_2 = {
  key: 1,
  "class": "footer"
};
var _hoisted_3 = {
  "class": "container"
};
var _hoisted_4 = {
  "class": "info"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "icon",
    src: _imports_0,
    alt: "aichiplink logo"
  }, null, -1);
});
var _hoisted_6 = {
  "class": "info-contact"
};
var _hoisted_7 = {
  "class": "socail"
};
var _hoisted_8 = {
  target: "_blank",
  href: "https://www.facebook.com/ai.chiplink.limited",
  title: "facebook",
  "class": "icon small-icon"
};
var _hoisted_9 = {
  target: "_blank",
  href: "https://www.linkedin.com/company/ai-chiplink-limited/",
  title: "linkedIn",
  "class": "icon ins"
};
var _hoisted_10 = {
  target: "_blank",
  href: "https://www.instagram.com/aichiplink_official/",
  title: "Ins",
  "class": "icon ins"
};
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  target: "_blank",
  href: "https://twitter.com/aichiplink",
  title: "twitter",
  "class": "icon ins"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  "class": "links"
};
var _hoisted_15 = {
  "class": "company"
};
var _hoisted_16 = {
  "class": "title"
};
var _hoisted_17 = {
  "class": "list"
};
var _hoisted_18 = {
  "class": "service"
};
var _hoisted_19 = {
  "class": "title"
};
var _hoisted_20 = {
  "class": "list"
};
var _hoisted_21 = {
  "class": "icons"
};
var _hoisted_22 = {
  "class": "payment"
};
var _hoisted_23 = {
  "class": "title"
};
var _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"list\" data-v-d417e1a6><div class=\"icon\" data-v-d417e1a6><img src=\"" + _imports_1 + "\" alt=\"paypal logo\" data-v-d417e1a6></div><div class=\"icon\" data-v-d417e1a6><img src=\"" + _imports_2 + "\" alt=\"visa logo\" data-v-d417e1a6></div><div class=\"icon\" data-v-d417e1a6><img src=\"" + _imports_3 + "\" alt=\"visa logo\" data-v-d417e1a6></div><div class=\"icon\" data-v-d417e1a6><img src=\"" + _imports_4 + "\" alt=\"american express logo\" data-v-d417e1a6></div></div>", 1);
var _hoisted_25 = {
  "class": "trans"
};
var _hoisted_26 = {
  "class": "title"
};
var _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"list\" data-v-d417e1a6><div class=\"icon\" data-v-d417e1a6><img src=\"" + _imports_5 + "\" alt=\"dhl logo\" data-v-d417e1a6></div><div class=\"icon\" data-v-d417e1a6><img src=\"" + _imports_6 + "\" alt=\"ems logo\" data-v-d417e1a6></div><div class=\"icon\" data-v-d417e1a6><img src=\"" + _imports_7 + "\" alt=\"fedex logo\" data-v-d417e1a6></div><div class=\"icon\" data-v-d417e1a6><img src=\"" + _imports_8 + "\" alt=\"ups logo\" data-v-d417e1a6></div></div>", 1);
var _hoisted_28 = {
  key: 2,
  "class": "copyright"
};
var _hoisted_29 = {
  "class": "container"
};
var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "text"
  }, "Copyright © 2024 Power by AIChiplink Limited", -1);
});
var _hoisted_31 = {
  "class": "links"
};
var _hoisted_32 = {
  key: 4,
  "class": "cookie-confirm"
};
var _hoisted_33 = {
  "class": "container"
};
var _hoisted_34 = {
  "class": "desc"
};
var _hoisted_35 = {
  "class": "cookie"
};
var _hoisted_36 = {
  "class": "btns"
};
import { ref, provide, onMounted, onBeforeMount, computed, defineAsyncComponent } from "vue";
import { useRouter, useRoute, onBeforeRouteUpdate } from "vue-router";
import { ElBacktop } from "element-plus";
import 'element-plus/es/components/backtop/style/css'

import { storeToRefs } from "pinia";
import Header from "./header.vue";
import BacktopIcon from "@/assets/svg/backtop.svg";
import LinkedinIcon from "@/assets/svg/footer-linkedin.svg";
import XIcon from "@/assets/img//webp/footer-x.webp";
import InsIcon from "@/assets/img/webp/footer-ins.webp";
import FacebookIcon from "@/assets/svg/footer-facebook.svg";
import { useGlobalStore } from "@/store/global";
import { useUserStore } from "@/store/user";
import { setLoginModalIsShow } from "@/util/user";
export default /*#__PURE__*/_defineComponent({
  __name: 'site',
  setup: function setup(__props) {
    var Rfq = defineAsyncComponent(function () {
      return import("@/components/rfq.vue");
    });
    var Login = defineAsyncComponent(function () {
      return import("./login/index.vue");
    });
    var onclickSkype = function onclickSkype() {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "sidebar_skype"
        });
      }
      window.open("https://join.skype.com/invite/vuLGEvR59Sr9");
    };
    var onclickWhatsapp = function onclickWhatsapp() {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "sidebar_whatsapp"
        });
      }
      window.open("https://wa.me/8613266689608");
    };
    var router = useRouter();
    var route = useRoute();
    var store = useUserStore();
    var globalStore = useGlobalStore();
    var hidePcHeader = ref(false);
    var cookieConfirm = ref(0); // 1 接受, 2 不接受
    var _storeToRefs = storeToRefs(globalStore),
      headerSearchIsShow = _storeToRefs.headerSearchIsShow,
      loginModalIsShow = _storeToRefs.loginModalIsShow,
      pageIsLoading = _storeToRefs.pageIsLoading;
    var isLogin = computed(function () {
      var _store$userInfo;
      return store === null || store === void 0 || (_store$userInfo = store.userInfo) === null || _store$userInfo === void 0 ? void 0 : _store$userInfo.userId;
    });
    var onclickEmail = function onclickEmail() {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "footer_email"
        });
      }
      window.open("mailto:info@aichiplink.com");
    };
    var isRefresh = ref(false);
    var reloadPage = function reloadPage() {
      isRefresh.value = true;
      setTimeout(function () {
        isRefresh.value = false;
      }, 10);
    };
    var onAccept = function onAccept() {
      var localStorageCookieConfirm = "1";
      localStorage.setItem("cookieConfirm", localStorageCookieConfirm);
      cookieConfirm.value = parseInt(localStorageCookieConfirm);
    };
    var onReject = function onReject() {
      var localStorageCookieConfirm = "2";
      localStorage.setItem("cookieConfirm", localStorageCookieConfirm);
      cookieConfirm.value = parseInt(localStorageCookieConfirm);
    };
    var onLogin = function onLogin() {
      setLoginModalIsShow(true);
    };
    onBeforeRouteUpdate(function (to) {
      if (to.name !== "home") {
        globalStore.setHeaderSearchIsShow(true);
      }
      var meta = to === null || to === void 0 ? void 0 : to.meta;
      hidePcHeader.value = !!(meta !== null && meta !== void 0 && meta.hidePcHeader);
    });
    onBeforeMount(function () {
      var localStorageCookieConfirm = localStorage.getItem("cookieConfirm") || "0";
      cookieConfirm.value = parseInt(localStorageCookieConfirm);
      if (cookieConfirm.value === 2) {
        window.dataLayer.push(["consent", "default", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied"
        }]);
      }
    });
    onMounted(function () {
      var _router$currentRoute, _router$currentRoute2;
      if ((router === null || router === void 0 || (_router$currentRoute = router.currentRoute) === null || _router$currentRoute === void 0 ? void 0 : _router$currentRoute.value.name) !== "home") {
        globalStore.setHeaderSearchIsShow(true);
      }
      var meta = router === null || router === void 0 || (_router$currentRoute2 = router.currentRoute) === null || _router$currentRoute2 === void 0 || (_router$currentRoute2 = _router$currentRoute2.value) === null || _router$currentRoute2 === void 0 ? void 0 : _router$currentRoute2.meta;
      hidePcHeader.value = !!(meta !== null && meta !== void 0 && meta.hidePcHeader);
    });
    provide("reloadPage", reloadPage);
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      var _component_router_link = _resolveComponent("router-link");
      var _component_a_button = __unplugin_components_0;
      var _directive_track = _resolveDirective("track");
      return _openBlock(), _createElementBlock(_Fragment, null, [!hidePcHeader.value ? (_openBlock(), _createBlock(Header, {
        key: "site-header"
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [!isRefresh.value ? (_openBlock(), _createBlock(_component_router_view, {
        key: _unref(route).path
      })) : _createCommentVNode("", true)]), !_unref(pageIsLoading) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
        "class": "logo",
        to: {
          name: 'home'
        }
      }, {
        "default": _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_6, [_withDirectives((_openBlock(), _createElementBlock("div", {
        "class": "email",
        onClick: onclickEmail
      }, [_createTextVNode(" info@aichiplink.com ")])), [[_directive_track, {
        action: ['show', 'click'],
        event: "email"
      }]])]), _createElementVNode("div", _hoisted_7, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, [_createVNode(_unref(FacebookIcon))])), [[_directive_track, {
        action: ['show', 'click'],
        event: "facebook"
      }]]), _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, [_createVNode(_unref(LinkedinIcon))])), [[_directive_track, {
        action: ['show', 'click'],
        event: "linkedin"
      }]]), _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [_createElementVNode("img", {
        "class": "icon",
        src: _unref(InsIcon)
      }, null, 8, _hoisted_11)])), [[_directive_track, {
        action: ['show', 'click'],
        event: "ins"
      }]]), _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_12, [_createElementVNode("img", {
        "class": "icon",
        src: _unref(XIcon)
      }, null, 8, _hoisted_13)])), [[_directive_track, {
        action: ['show', 'click'],
        event: "twitter"
      }]])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("Company")), 1), _createElementVNode("div", _hoisted_17, [_createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'about-us'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("About Us")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'blog'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Blog")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'quality-control'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Quality Control")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'contact-us'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Contact Us")), 1)];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("Resources")), 1), _createElementVNode("div", _hoisted_20, [_createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'category'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Categories")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'manufacturer'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Manufacturer")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'rfq'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Request a Quote")), 1)];
        }),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("Payment")), 1), _hoisted_24]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("Shipping")), 1), _hoisted_27])])]), _createVNode(_unref(Rfq))])) : _createCommentVNode("", true), !_unref(pageIsLoading) ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, [_createVNode(_component_router_link, {
        target: "_blank",
        "class": "link",
        to: {
          name: 'privacy-policy'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Privacy Policy")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        target: "_blank",
        "class": "link",
        to: {
          name: 'term-of-use'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Terms & Conditions")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        target: "_blank",
        "class": "link",
        to: {
          name: 'cookie-policy'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Cookies")), 1)];
        }),
        _: 1
      })])])])) : _createCommentVNode("", true), _createVNode(_unref(ElBacktop), {
        "class": "backtop",
        right: 100,
        bottom: 100
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_unref(BacktopIcon), {
            "class": "icon"
          })];
        }),
        _: 1
      }), _unref(loginModalIsShow) ? (_openBlock(), _createBlock(_unref(Login), {
        key: 3
      })) : _createCommentVNode("", true), cookieConfirm.value == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createTextVNode(_toDisplayString(_ctx.$t("We use cookies to give you the best possible experience with aichiplink.com. Some are essential for this site to function; others help us understand how you use the site, so we can improve it. We may also use cookies for targeting purposes.")) + " ", 1), _createVNode(_component_router_link, {
        to: {
          name: 'cookie-policy'
        }
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("Cookie Notice")), 1)];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_36, [_createVNode(_component_a_button, {
        type: "primary",
        onClick: onAccept,
        "class": "btn accept"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Accept")), 1)];
        }),
        _: 1
      }), _createVNode(_component_a_button, {
        "class": "btn",
        onClick: onReject
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Reject")), 1)];
        }),
        _: 1
      })])])])) : _createCommentVNode("", true)], 64);
    };
  }
});